module.exports = __webpack_public_path__ + "img/hr-pumpjack-base-shadow.d4026e6a.png";